import { defaultRegionInfoProvider } from "./endpoints";
export var ClientSharedValues = {
    apiVersion: "2014-06-30",
    disableHostPrefix: false,
    signingName: "cognito-identity",
    regionInfoProvider: defaultRegionInfoProvider
};
//# sourceMappingURL=runtimeConfig.shared.js.map